import apiService from 'frontcore/data/api-service/api-service'
import HttpStatusCode from 'frontcore/data/api-service/http-status-code'
import { IProductionFormatAPIService, ProductionFormat } from 'frontcore/domain/production-format/types'
import { ProductionFormatAPIServiceError } from 'frontcore/data/production-format/types'

const PRODUCTION_FORMAT_API_URL = 'production-formats'

type ProductionFormatAPIResponse = {
  id: number
  created: string
  device_update: string
  updated: string
  deletable: boolean
  name: string
  enabled: boolean
  description: string
  production_hierarchy: number | null
  perimeter: number[]
}

const parseProductionFormatAPIResponse = (productionFormatAPIResponse: ProductionFormatAPIResponse[]): ProductionFormat[] => {
  return productionFormatAPIResponse.map(productionFormat => {
    return {
      id: productionFormat.id,
      name: productionFormat.name,
      description: productionFormat.description,
      enabled: productionFormat.enabled,
      productionHierarchy: productionFormat.production_hierarchy,
      perimeter: productionFormat.perimeter,
      deletable: productionFormat.deletable,
      updated: productionFormat.updated,
      created: productionFormat.created,
    }
  })
}

export default class ProductionFormatAPIService implements IProductionFormatAPIService {
  async fetch (): Promise<ProductionFormat[]>{
    try {
      const url = `${PRODUCTION_FORMAT_API_URL}/`
      const response = await apiService
        .buildRequest()
        .withSessionToken()
        .get<ProductionFormatAPIResponse[]>(url)

      if (response.status !== HttpStatusCode.OK) {
        throw new ProductionFormatAPIServiceError()
      }

      return parseProductionFormatAPIResponse(response.data)

    } catch(e) {
      if (e instanceof ProductionFormatAPIServiceError) { throw e }
      throw new ProductionFormatAPIServiceError((e as Error).message)
    }
  }
}
